var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.DispositivosTotalesSim,
        callback: function($$v) {
          _vm.DispositivosTotalesSim = $$v
        },
        expression: "DispositivosTotalesSim"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { fluid: "", white: "" } },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.ubicacion.label,
                          items: _vm.ubicaciones,
                          "item-text": "tipoubicaname",
                          "item-value": "tipoubicaid",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.ubicacion.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.ubicacion, "value", $$v)
                          },
                          expression: "formFields.ubicacion.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.formFields.telco.label,
                          items: _vm.telcos,
                          "item-text": "telconame",
                          "item-value": "telcoid",
                          clearable: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.cargarPlanes()
                          },
                          "click:clear": function($event) {
                            _vm.planes = []
                          }
                        },
                        model: {
                          value: _vm.formFields.telco.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.telco, "value", $$v)
                          },
                          expression: "formFields.telco.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.formFields.plan.label,
                          items: _vm.planes,
                          "item-text": "telcoplanname",
                          "item-value": "telcoplanid",
                          "no-data-text": !_vm.formFields.telco.value
                            ? "Por favor seleccione una Telco para cargar los planes"
                            : "No hay planes para esa Telco",
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.plan.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.plan, "value", $$v)
                          },
                          expression: "formFields.plan.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.formFields.equipoSerie.label,
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.equipoSerie.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.equipoSerie, "value", $$v)
                          },
                          expression: "formFields.equipoSerie.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "ml-2",
                        attrs: {
                          label: _vm.formFields.simSerie.label,
                          clearable: ""
                        },
                        model: {
                          value: _vm.formFields.simSerie.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.simSerie, "value", $$v)
                          },
                          expression: "formFields.simSerie.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { xs4: "", sm4: "", md4: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros mt-1" },
                      [
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.filtroRequerimiento(true)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("search")
                            ]),
                            _vm._v("Filtrar\n            ")
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            on: {
                              click: function($event) {
                                return _vm.clearFilters()
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "#27488e" } }, [
                              _vm._v("clear")
                            ]),
                            _vm._v("Limpiar")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            {},
            [
              _c(
                "div",
                { staticClass: "gridcard rounded-card totalSims" },
                [
                  _c("MantenedorGrid", {
                    staticClass: "ag-theme-material",
                    staticStyle: { "font-family": "'Asap', sans-serif" },
                    attrs: { gridOptions: _vm.gridOptions }
                  })
                ],
                1
              ),
              _c(
                "v-layout",
                { staticClass: "mt-3", attrs: { row: "", wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs8: "", sm8: "", md9: "" } }),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { xs4: "", sm4: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-volver white--text",
                          on: {
                            click: function($event) {
                              return _vm.cerrarModal()
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar white--text",
                          on: {
                            click: function($event) {
                              return _vm.guardar()
                            }
                          }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }